export default function permute(source, keys) {
  return Array.from(keys, key => source[key]);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/permute.js
// module id = 163
// module chunks = 0